// Import GSAP and plugins
import gsap from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomEase from "gsap/CustomEase";

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger, CustomEase);

// Export for reuse in other modules
export { gsap, ScrollTrigger, CustomEase };

// Import Splitting styles and init
import "splitting/dist/splitting.css";
import "splitting/dist/splitting-cells.css";
import Splitting from "splitting";

Splitting();

export function isLargeNonTouchDevice() {
  const isWideScreen = window.innerWidth > 1024;
  const isNotTouchDevice = !('ontouchstart' in window || navigator.maxTouchPoints > 0);
  return isWideScreen && isNotTouchDevice;
}
